var _clipPath, _clipPath2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3710 3710",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1661.9,3166.49C1634.51,3166.49 1607.38,3165.78 1580.55,3164.36L1744.54,3164.36C1716.79,3165.78 1689.21,3166.49 1661.9,3166.49ZM1244.92,3116.71C1109.57,3081.49 958.849,3016.93 827.942,2893.14C419.927,2507.29 423.777,1753.46 729.98,1207.31L798.8,1665.33C801.868,1685.75 819.408,1700.85 840.053,1700.85L1505.34,1700.85L1505.34,1126.49L778.504,1126.49C809.746,1077.84 843.583,1031.19 879.859,987.089C936.981,917.644 1330.14,455 1943.35,455C1947.45,455 1951.56,455.021 1955.68,455.063C2409.81,459.652 2728.57,716.186 2767.32,748.145C2816.29,788.518 2924.28,884.457 3021.61,1036.66C3250.29,1394.28 3270.39,1893.52 3099.3,2293.42C3084.09,2328.97 3067.53,2363.33 3049.66,2396.63C3024.95,2386.43 2997.87,2380.8 2969.47,2380.8C2853.36,2380.8 2759.23,2474.93 2759.23,2591.04C2759.23,2639.95 2775.93,2684.95 2803.94,2720.67C2702.4,2819.04 2587.09,2900.68 2464.27,2966.03L2542.75,2704.64C2642.91,2688.56 2719.43,2601.75 2719.43,2497.06C2719.43,2432.31 2690.16,2374.39 2644.13,2335.83L2798.38,1822.06C2799.42,1818.58 2796.73,1815.37 2793.43,1815.37C2792.85,1815.37 2792.24,1815.47 2791.64,1815.68C2695.77,1849.82 2407.89,1865.91 2113.18,1865.91C1808.89,1865.91 1497.33,1848.75 1382.48,1816.61C1381.67,1816.38 1380.87,1816.28 1380.09,1816.28C1374.54,1816.28 1370.13,1821.67 1371.84,1827.41L1381.06,1858.25L982.952,1858.25C970.602,1858.25 961.145,1869.23 962.98,1881.44L1040.46,2397.09C1043.53,2417.5 1061.07,2432.6 1081.71,2432.6L1564.99,2432.6C1579.75,2447.05 1599.15,2456.6 1620.54,2459.06C1772.28,2476.51 1925.87,2485.46 2081.43,2485.46C2153.75,2485.46 2226.48,2483.53 2299.67,2479.61C2299.19,2485.36 2298.95,2491.18 2298.95,2497.06C2298.95,2504.65 2299.35,2512.14 2300.14,2519.53C2233.71,2517.67 2159.3,2516.63 2080.7,2516.63C1800.03,2516.63 1584.85,2526.21 1584.85,2542.56L1584.85,2542.68C1580.69,2543.69 1577.86,2548.05 1579.21,2552.55L1590.4,2590L1202.19,2590C1183.03,2590 1168.35,2607.05 1171.19,2626.01L1244.92,3116.71ZM2198.38,504.115C2126.23,504.115 2056.09,542.076 2035.54,628.749C2016.22,710.187 2036.04,780.001 2050.32,815.682C2056.98,832.335 2060.29,850.16 2060.02,868.093C2059.46,905.413 2067.82,969.861 2129.73,985.125C2136.8,986.87 2143.51,987.665 2149.86,987.665C2186.45,987.665 2211.18,961.25 2225.94,937.721C2240.1,915.163 2259.42,896.335 2282.57,883.162C2319.02,862.419 2371.44,822.997 2397.61,758.204C2440.14,652.902 2368.1,554.953 2276.21,518.892C2251.56,509.217 2224.84,504.115 2198.38,504.115Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.34,1700.85L840.053,1700.85C819.408,1700.85 801.868,1685.75 798.8,1665.33L729.98,1207.31L721.322,1149.69C719.487,1137.47 728.945,1126.49 741.293,1126.49L1505.34,1126.49L1505.34,1700.85ZM873.406,1481.03C870.587,1481.03 868.443,1483.56 868.909,1486.34L879.475,1549.32C879.843,1551.52 881.746,1553.13 883.971,1553.13L1261.21,1553.13C1264.24,1553.13 1266.43,1550.22 1265.59,1547.3L1247.82,1485.53C1247.06,1482.86 1244.62,1481.03 1241.85,1481.03L873.406,1481.03ZM855.675,1369.02C852.243,1369.02 849.636,1372.11 850.207,1375.49L863.153,1452.13C863.604,1454.8 865.914,1456.75 868.62,1456.75L1240.89,1456.75C1243.73,1456.75 1245.79,1454.05 1245.04,1451.31L1223.71,1373.64C1223.26,1370.98 1220.95,1369.02 1218.25,1369.02L855.675,1369.02ZM842.674,1276.85C836.999,1276.85 832.711,1282 833.734,1287.58L843.124,1338.86C843.915,1343.18 847.677,1346.31 852.065,1346.31L1217.18,1346.31C1220.71,1346.31 1223.3,1342.99 1222.43,1339.57L1208.52,1284.41C1207.77,1280.05 1203.99,1276.85 1199.56,1276.85L842.674,1276.85Z",
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.89,1456.75L868.62,1456.75C865.914,1456.75 863.604,1454.8 863.153,1452.13L850.207,1375.49C849.636,1372.11 852.243,1369.02 855.675,1369.02L1218.25,1369.02C1220.95,1369.02 1223.26,1370.98 1223.71,1373.64L1245.04,1451.31C1245.79,1454.05 1243.73,1456.75 1240.89,1456.75Z",
    style: {
      fill: "url(#_Linear3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.971,1553.13C881.746,1553.13 879.843,1551.52 879.475,1549.32L868.909,1486.34C868.443,1483.56 870.587,1481.03 873.406,1481.03L1241.85,1481.03C1244.62,1481.03 1247.06,1482.86 1247.82,1485.53L1265.59,1547.3C1266.43,1550.22 1264.24,1553.13 1261.21,1553.13L883.971,1553.13Z",
    style: {
      fill: "url(#_Linear4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.18,1346.31L852.065,1346.31C847.677,1346.31 843.915,1343.18 843.124,1338.86L833.734,1287.58C832.711,1282 836.999,1276.85 842.674,1276.85L1199.56,1276.85C1203.99,1276.85 1207.77,1280.05 1208.52,1284.41L1222.43,1339.57C1223.3,1342.99 1220.71,1346.31 1217.18,1346.31Z",
    style: {
      fill: "url(#_Linear5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747,2432.6L1081.71,2432.6C1061.07,2432.6 1043.53,2417.5 1040.46,2397.09L962.98,1881.44C961.145,1869.23 970.602,1858.25 982.952,1858.25L1747,1858.25L1747,2432.6Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.41,2188.36L1064.13,2188.36C1061.43,2188.36 1059.12,2186.41 1058.67,2183.74L1045.72,2107.11C1045.15,2103.72 1047.76,2100.64 1051.19,2100.64L1413.76,2100.64C1416.47,2100.64 1418.78,2102.59 1419.23,2105.26L1440.55,2182.93C1441.3,2185.66 1439.24,2188.36 1436.41,2188.36Z",
    style: {
      fill: "rgb(189,202,249)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.49,2284.74C1077.26,2284.74 1075.36,2283.14 1074.99,2280.94L1064.42,2217.95C1063.96,2215.17 1066.1,2212.64 1068.92,2212.64L1437.36,2212.64C1440.13,2212.64 1442.57,2214.48 1443.34,2217.14L1461.11,2278.92C1461.95,2281.84 1459.76,2284.74 1456.72,2284.74L1079.49,2284.74Z",
    style: {
      fill: "rgb(189,202,249)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.7,2077.93L1047.58,2077.93C1043.19,2077.93 1039.43,2074.79 1038.64,2070.47L1029.25,2019.19C1028.23,2013.61 1032.51,2008.47 1038.19,2008.47L1395.07,2008.47C1399.5,2008.47 1403.29,2011.66 1404.03,2016.03L1417.95,2071.18C1418.81,2074.6 1416.22,2077.93 1412.7,2077.93Z",
    style: {
      fill: "rgb(189,202,249)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.27,3164.36L1296.82,3164.36C1271.1,3164.36 1249.26,3145.55 1245.44,3120.12L1244.92,3116.71L1171.19,2626.01C1168.35,2607.05 1183.03,2590 1202.19,2590L1590.4,2590L1749.44,3122.24C1754.34,3138.63 1763.37,3153.03 1775.27,3164.36ZM1285.02,2943.22C1282.2,2943.22 1280.05,2945.75 1280.52,2948.53L1291.09,3011.52C1291.45,3013.71 1293.36,3015.32 1295.58,3015.32L1672.82,3015.32C1675.85,3015.32 1678.04,3012.41 1677.2,3009.5L1659.44,2947.72C1658.67,2945.05 1656.23,2943.22 1653.46,2943.22L1285.02,2943.22ZM1267.29,2831.22C1263.85,2831.22 1261.25,2834.3 1261.82,2837.68L1274.76,2914.32C1275.21,2916.99 1277.52,2918.94 1280.23,2918.94L1652.5,2918.94C1655.34,2918.94 1657.4,2916.24 1656.65,2913.5L1635.32,2835.84C1634.87,2833.17 1632.56,2831.22 1629.86,2831.22L1267.29,2831.22ZM1254.29,2739.05C1248.61,2739.05 1244.32,2744.19 1245.35,2749.77L1254.73,2801.05C1255.53,2805.37 1259.29,2808.5 1263.68,2808.5L1628.79,2808.5C1632.32,2808.5 1634.91,2805.18 1634.04,2801.76L1620.13,2746.61C1619.38,2742.24 1615.6,2739.05 1611.17,2739.05L1254.29,2739.05Z",
    style: {
      fill: "url(#_Linear6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.5,2918.94L1280.23,2918.94C1277.52,2918.94 1275.21,2916.99 1274.76,2914.32L1261.82,2837.68C1261.25,2834.3 1263.85,2831.22 1267.29,2831.22L1629.86,2831.22C1632.56,2831.22 1634.87,2833.17 1635.32,2835.84L1656.65,2913.5C1657.4,2916.24 1655.34,2918.94 1652.5,2918.94Z",
    style: {
      fill: "url(#_Linear7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.58,3015.32C1293.36,3015.32 1291.45,3013.71 1291.09,3011.52L1280.52,2948.53C1280.05,2945.75 1282.2,2943.22 1285.02,2943.22L1653.46,2943.22C1656.23,2943.22 1658.67,2945.05 1659.44,2947.72L1677.2,3009.5C1678.04,3012.41 1675.85,3015.32 1672.82,3015.32L1295.58,3015.32Z",
    style: {
      fill: "url(#_Linear8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.79,2808.5L1263.68,2808.5C1259.29,2808.5 1255.53,2805.37 1254.73,2801.05L1245.35,2749.77C1244.32,2744.19 1248.61,2739.05 1254.29,2739.05L1611.17,2739.05C1615.6,2739.05 1619.38,2742.24 1620.13,2746.61L1634.04,2801.76C1634.91,2805.18 1632.32,2808.5 1628.79,2808.5Z",
    style: {
      fill: "url(#_Linear9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2088.45,2579.89C1918.86,2579.89 1745.72,2567.79 1587.96,2542.56C1587.53,2542.49 1587.1,2542.46 1586.68,2542.46C1586.05,2542.46 1585.44,2542.53 1584.85,2542.68L1584.85,2542.56C1584.85,2526.21 1800.03,2516.63 2080.7,2516.63C2159.3,2516.63 2233.71,2517.67 2300.14,2519.53C2302.11,2538.07 2306.49,2555.89 2312.96,2572.67C2239.97,2577.45 2164.58,2579.89 2088.45,2579.89Z",
    style: {
      fill: "url(#_Linear10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2798.61,1815.37C2798.61,1836.02 2446.12,1887.01 2050.06,1887.01C1654,1887.01 1382.48,1837.27 1382.48,1816.61C1382.48,1795.95 1688.26,1781.04 2084.32,1781.04C2480.38,1781.04 2798.61,1794.71 2798.61,1815.37Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2540.63,2459.67C2226.19,2494.84 1919.74,2493.47 1620.54,2459.06C1582.92,2454.73 1551.45,2428.49 1540.61,2392.21L1371.84,1827.41C1369.89,1820.86 1375.9,1814.77 1382.48,1816.61C1608.56,1879.88 2596.79,1885.07 2791.64,1815.68C2795.67,1814.24 2799.61,1817.97 2798.38,1822.06L2629.06,2385.99C2617.03,2426.06 2582.21,2455.02 2540.63,2459.67Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082.78,3208.58C1997.64,3208.58 1912.85,3202.41 1828.4,3190.16C1808.03,3187.21 1789.58,3178 1775.27,3164.36C1763.37,3153.03 1754.34,3138.63 1749.44,3122.24L1590.4,2590L1579.21,2552.55C1577.86,2548.05 1580.69,2543.69 1584.85,2542.68C1585.44,2542.53 1586.05,2542.46 1586.68,2542.46C1587.1,2542.46 1587.53,2542.49 1587.96,2542.56C1745.72,2567.79 1918.86,2579.89 2088.45,2579.89C2164.58,2579.89 2239.97,2577.45 2312.96,2572.67C2343.33,2651.43 2419.73,2707.3 2509.19,2707.3C2520.62,2707.3 2531.82,2706.39 2542.75,2704.64L2464.27,2966.03L2419.25,3115.99C2407.26,3155.93 2373.09,3185.22 2331.79,3191.03C2248.46,3202.76 2165.45,3208.58 2082.78,3208.58Z",
    style: {
      fill: "url(#_Linear11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2991.96,1082.85C2991.96,1106.95 2592.63,1126.49 2085.4,1126.49C1578.17,1126.49 1178.89,1106.95 1178.89,1082.85C1178.89,1058.75 1578.17,1039.22 2085.4,1039.22C2592.63,1039.22 2991.96,1058.75 2991.96,1082.85Z",
    style: {
      fill: "url(#_Linear12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.95,1179.02C1606.44,1200.3 1666.64,1206.35 1727.09,1193.02C1838.09,1168.54 1920.85,1085.12 1949.78,982.904L1662.9,901.991L1552.95,1179.02Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.78,982.904C1962.74,937.104 1964.9,887.537 1953.93,837.802C1949.5,817.694 1943.13,798.513 1935.06,780.409L1662.9,901.991L1949.78,982.904Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935.06,780.409C1907.09,717.617 1858.71,667.812 1799.9,637.329L1662.9,901.991L1935.06,780.409Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.5,907.592L1459.43,668.53C1368.37,736.439 1320.42,853.651 1346.47,971.781C1368.59,1072.06 1438.82,1149.31 1527.55,1184.62L1637.5,907.592Z",
    style: {
      fill: "url(#_Linear13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.9,637.329C1773.57,623.68 1745.14,613.909 1715.52,608.583C1697.9,720.518 1662.9,901.991 1662.9,901.991L1799.9,637.329Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.52,608.583C1677.91,601.822 1638.36,602.215 1598.71,610.96C1556.11,620.356 1517.67,638.437 1484.83,662.928L1662.9,901.991C1662.9,901.991 1697.9,720.518 1715.52,608.583Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2345.87,959.457C2345.87,959.457 2416.63,1146.06 2438.98,1184.87C2464.93,1229.93 2540.71,1201.22 2536.94,1163.51C2533.17,1125.8 2444.63,969.93 2444.63,969.93L2345.87,959.457Z",
    style: {
      fill: "url(#_Linear14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2441.47,823.528L2881.23,671.058L2876.61,1083.67L2429.46,983.896L2441.47,823.528Z",
    style: {
      fill: "url(#_Linear15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2924.85,878.56C2924.85,995.668 2905.51,1090.6 2881.65,1090.6C2857.79,1090.6 2838.44,995.668 2838.44,878.56C2838.44,761.451 2857.79,666.517 2881.65,666.517C2905.51,666.517 2924.85,761.451 2924.85,878.56Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2884.93,1076.1C2881.02,1072.13 2872.51,1056.81 2865.22,1017.19C2858.17,978.907 2854.29,929.248 2854.29,877.363C2854.29,825.478 2858.17,775.819 2865.22,737.533C2872.51,697.915 2881.02,682.595 2884.93,678.623C2888.83,682.595 2897.34,697.915 2904.63,737.533C2911.68,775.819 2915.56,825.478 2915.56,877.363C2915.56,929.248 2911.68,978.907 2904.63,1017.19C2897.34,1056.81 2888.83,1072.13 2884.93,1076.1Z",
    style: {
      fill: "url(#_Linear16)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2884.93,1076.1C2881.02,1072.13 2872.51,1056.81 2865.22,1017.19C2858.17,978.907 2854.29,929.247 2854.29,877.363C2854.29,825.478 2858.17,775.819 2865.22,737.533C2872.51,697.915 2881.02,682.595 2884.93,678.622C2888.83,682.595 2897.34,697.915 2904.63,737.533C2911.68,775.819 2967.3,825.478 2967.3,877.363C2967.3,929.247 2911.68,978.907 2904.63,1017.19C2897.34,1056.81 2888.83,1072.13 2884.93,1076.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip17)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2940.3,875.784C2940.3,911.812 2920.89,941.019 2882.48,941.019C2844.07,941.019 2812.93,911.812 2812.93,875.784C2812.93,839.755 2844.07,810.548 2882.48,810.548C2920.89,810.548 2940.3,839.755 2940.3,875.784Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip18)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2854.29,
    y: 810.548,
    width: 86.01,
    height: 130.471,
    style: {
      fill: "url(#_Linear19)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2370.55,814.659C2391.24,812.256 2420.9,811.392 2452.97,818.737C2442.41,873.938 2444,931.473 2456.22,991.048L2365.76,991.048C2351.33,991.048 2339.04,980.572 2336.79,966.325C2332.28,937.768 2326.77,889.771 2332.64,851.221C2335.59,831.875 2351.11,816.917 2370.55,814.659Z",
    style: {
      fill: "url(#_Linear20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2424.84,856.936L2354.36,856.936C2351.97,856.936 2349.85,855.681 2348.71,853.58C2347.57,851.478 2347.66,849.024 2348.96,847.016C2349.5,846.175 2350.63,845.939 2351.47,846.479C2352.31,847.022 2352.55,848.145 2352,848.986C2351.44,849.862 2351.4,850.931 2351.9,851.847C2352.39,852.763 2353.31,853.311 2354.36,853.311L2424.84,853.311C2426.39,853.311 2427.64,852.054 2427.64,850.508L2427.64,845.492C2427.64,843.946 2426.39,842.69 2424.84,842.69L2353.83,842.69C2352.83,842.69 2352.02,841.878 2352.02,840.877C2352.02,839.877 2352.83,839.065 2353.83,839.065L2424.84,839.065C2428.39,839.065 2431.27,841.949 2431.27,845.492L2431.27,850.508C2431.27,854.052 2428.39,856.936 2424.84,856.936Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2418.56,888.151L2348.07,888.151C2345.68,888.151 2343.57,886.896 2342.43,884.795C2341.28,882.694 2341.38,880.239 2342.68,878.231C2343.22,877.392 2344.34,877.155 2345.18,877.694C2346.02,878.238 2346.26,879.36 2345.72,880.202C2345.15,881.077 2345.11,882.146 2345.61,883.063C2346.11,883.979 2347.03,884.526 2348.07,884.526L2418.56,884.526C2420.1,884.526 2421.36,883.27 2421.36,881.724L2421.36,876.709C2421.36,875.163 2420.1,873.905 2418.56,873.905L2347.55,873.905C2346.55,873.905 2345.74,873.094 2345.74,872.093C2345.74,871.092 2346.55,870.281 2347.55,870.281L2418.56,870.281C2422.1,870.281 2424.98,873.165 2424.98,876.709L2424.98,881.724C2424.98,885.267 2422.1,888.151 2418.56,888.151Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505.37,812.36C2504.61,812.36 2503.89,811.868 2503.65,811.098C2503.34,810.143 2503.87,809.125 2504.83,808.82L2837.89,702.832C2838.85,702.529 2839.87,703.057 2840.17,704.01C2840.47,704.964 2839.95,705.983 2838.99,706.287L2505.92,812.275C2505.74,812.333 2505.56,812.36 2505.37,812.36Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.33,830.772C2459.62,830.772 2458.94,830.348 2458.66,829.646C2458.28,828.719 2458.72,827.661 2459.65,827.282L2476.79,820.275C2477.72,819.895 2478.77,820.341 2479.15,821.268C2479.53,822.194 2479.09,823.252 2478.16,823.631L2461.02,830.638C2460.79,830.73 2460.56,830.772 2460.33,830.772Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2424.84,924.709L2354.36,924.709C2351.97,924.709 2349.86,923.455 2348.71,921.354C2347.57,919.252 2347.66,916.798 2348.96,914.79C2349.5,913.948 2350.63,913.711 2351.47,914.251C2352.31,914.795 2352.55,915.918 2352,916.758C2351.44,917.635 2351.4,918.705 2351.9,919.622C2352.39,920.537 2353.31,921.085 2354.36,921.085L2424.84,921.085C2426.39,921.085 2427.64,919.827 2427.64,918.281L2427.64,913.267C2427.64,911.721 2426.39,910.464 2424.84,910.464L2353.83,910.464C2352.83,910.464 2352.02,909.652 2352.02,908.651C2352.02,907.651 2352.83,906.839 2353.83,906.839L2424.84,906.839C2428.39,906.839 2431.27,909.723 2431.27,913.267L2431.27,918.281C2431.27,921.826 2428.39,924.709 2424.84,924.709Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2431.44,965.288L2360.96,965.288C2358.56,965.288 2356.46,964.034 2355.31,961.933C2354.17,959.831 2354.26,957.376 2355.56,955.368C2356.11,954.527 2357.23,954.29 2358.07,954.83C2358.91,955.375 2359.15,956.497 2358.6,957.336C2358.04,958.213 2358,959.283 2358.5,960.2C2358.99,961.116 2359.91,961.664 2360.96,961.664L2431.44,961.664C2432.99,961.664 2434.24,960.407 2434.24,958.861L2434.24,953.845C2434.24,952.299 2432.99,951.042 2431.44,951.042L2360.43,951.042C2359.43,951.042 2358.62,950.231 2358.62,949.23C2358.62,948.229 2359.43,947.418 2360.43,947.418L2431.44,947.418C2434.99,947.418 2437.87,950.302 2437.87,953.845L2437.87,958.861C2437.87,962.404 2434.99,965.288 2431.44,965.288Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494.39,1185.91C2491.14,1185.91 2487.86,1185.56 2484.59,1184.85C2470.26,1181.73 2458.59,1172.28 2452.58,1158.92L2396.27,1033.82C2395.86,1032.91 2396.26,1031.84 2397.18,1031.42C2398.09,1031.01 2399.16,1031.42 2399.57,1032.33L2455.88,1157.44C2461.42,1169.73 2472.16,1178.43 2485.36,1181.31C2498.33,1184.14 2511.45,1180.78 2521.37,1172.1C2521.9,1171.64 2522.43,1171.16 2522.97,1170.67C2523.71,1169.99 2524.85,1170.04 2525.53,1170.78C2526.2,1171.52 2526.15,1172.67 2525.41,1173.34C2524.86,1173.85 2524.3,1174.35 2523.75,1174.83C2515.47,1182.08 2505.13,1185.91 2494.39,1185.91Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2389.59,1016.39C2388.9,1016.39 2388.24,1015.99 2387.94,1015.32L2381.66,1001.37C2381.25,1000.46 2381.65,999.383 2382.57,998.971C2383.48,998.561 2384.55,998.969 2384.96,999.88L2391.25,1013.83C2391.66,1014.75 2391.25,1015.82 2390.34,1016.23C2390.1,1016.34 2389.84,1016.39 2389.59,1016.39Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930.01,873.905C2929.06,873.905 2928.27,873.176 2928.2,872.222C2926.95,854.568 2920.83,841.407 2910.01,833.104C2891.31,818.745 2864.63,823.68 2864.36,823.733C2863.37,823.92 2862.42,823.28 2862.23,822.297C2862.04,821.313 2862.69,820.363 2863.67,820.174C2864.83,819.951 2892.24,814.889 2912.22,830.229C2923.89,839.19 2930.49,853.233 2931.81,871.964C2931.89,872.963 2931.13,873.83 2930.13,873.901L2930.01,873.905Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2198.42,1006.56C2199.09,1003.44 2196.76,999.871 2192.12,996.181C2198.8,994.732 2202.98,992.293 2203.7,988.892C2205.89,978.601 2175.75,963.464 2136.38,955.083C2097,946.702 2063.31,948.25 2061.12,958.541C2060.46,961.662 2062.78,965.23 2067.42,968.919C2060.75,970.368 2056.57,972.808 2055.84,976.208C2055.18,979.33 2057.5,982.897 2062.15,986.587C2055.47,988.035 2051.29,990.475 2050.57,993.876C2049.9,996.998 2052.23,1000.57 2056.87,1004.25C2050.2,1005.7 2046.02,1008.14 2045.29,1011.54C2044.32,1016.1 2049.69,1021.59 2059.37,1027.04C2058.25,1030.28 2057.25,1033.9 2056.39,1037.98C2052.36,1056.94 2068.86,1077.68 2096.4,1085.91C2123.95,1094.13 2153.71,1081.46 2159.53,1062.96C2160.95,1058.43 2161.96,1054.37 2162.61,1050.68C2177.1,1050.22 2186.74,1047.24 2187.87,1041.9C2188.54,1038.77 2186.21,1035.21 2181.57,1031.52C2188.24,1030.07 2192.42,1027.63 2193.15,1024.23C2193.81,1021.11 2191.49,1017.54 2186.85,1013.85C2193.52,1012.4 2197.7,1009.96 2198.42,1006.56Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2091.36,1040.95C2079.94,1037.54 2069.74,1033.58 2061.61,1029.35C2061.13,1029.1 2060.95,1028.52 2061.19,1028.05C2061.44,1027.58 2062.02,1027.39 2062.49,1027.64C2075.23,1034.26 2093.1,1040.21 2112.82,1044.41C2128.95,1047.84 2144.44,1049.7 2157.61,1049.79C2158.15,1049.79 2158.58,1050.22 2158.57,1050.75C2158.57,1051.29 2158.13,1051.72 2157.6,1051.71C2144.3,1051.63 2128.67,1049.76 2112.42,1046.3C2105.09,1044.74 2098.02,1042.94 2091.36,1040.95Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2096.83,1023.32C2082,1018.89 2069.16,1013.54 2060.6,1008.08C2060.15,1007.79 2060.02,1007.2 2060.3,1006.75C2060.59,1006.3 2061.18,1006.17 2061.63,1006.46C2073.83,1014.23 2094.93,1021.81 2118.09,1026.74C2141,1031.62 2163.22,1033.31 2177.53,1031.27C2178.05,1031.19 2178.54,1031.56 2178.62,1032.08C2178.69,1032.61 2178.33,1033.1 2177.8,1033.17C2163.28,1035.25 2140.81,1033.55 2117.69,1028.63C2110.48,1027.09 2103.46,1025.3 2096.83,1023.32Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2101.91,1005.61C2085.9,1000.83 2072.37,995.001 2063.86,989.073C2063.43,988.769 2063.32,988.167 2063.62,987.731C2063.93,987.294 2064.53,987.186 2064.96,987.491C2076.8,995.741 2098.63,1003.81 2123.37,1009.08C2146.28,1013.95 2168.49,1015.64 2182.8,1013.6C2183.33,1013.52 2183.82,1013.89 2183.89,1014.42C2183.97,1014.94 2183.6,1015.43 2183.08,1015.51C2168.55,1017.58 2146.08,1015.88 2122.97,1010.96C2115.64,1009.4 2108.56,1007.59 2101.91,1005.61Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2107.32,987.97C2094.61,984.176 2083.36,979.697 2074.97,975.018C2074.51,974.758 2074.34,974.171 2074.6,973.707C2074.86,973.242 2075.45,973.075 2075.91,973.335C2088.52,980.371 2107.75,986.958 2128.64,991.407C2151.35,996.24 2173.44,997.948 2187.75,995.976C2188.28,995.902 2188.77,996.271 2188.84,996.799C2188.91,997.326 2188.54,997.812 2188.02,997.885C2173.5,999.887 2151.15,998.169 2128.24,993.292C2121,991.751 2113.96,989.954 2107.32,987.97Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2149.86,987.665C2143.51,987.665 2136.8,986.87 2129.73,985.125C2067.82,969.861 2059.46,905.413 2060.02,868.093C2060.29,850.16 2056.98,832.335 2050.32,815.682C2036.04,780.001 2016.22,710.187 2035.54,628.749C2056.09,542.076 2126.23,504.115 2198.38,504.115C2224.84,504.115 2251.56,509.217 2276.21,518.892C2368.1,554.953 2440.14,652.902 2397.61,758.204C2371.44,822.997 2319.02,862.419 2282.57,883.162C2259.42,896.335 2240.1,915.163 2225.94,937.721C2211.18,961.25 2186.45,987.665 2149.86,987.665ZM2315.42,826.383C2313.9,826.383 2312.38,826.942 2311.19,828.067C2304.36,834.518 2296.93,840.754 2289.11,846.603C2286.38,848.644 2285.82,852.508 2287.86,855.234C2288.68,856.335 2289.81,857.083 2291.03,857.449C2291.61,857.621 2292.2,857.708 2292.8,857.708C2294.09,857.708 2295.38,857.308 2296.49,856.48C2304.69,850.349 2312.48,843.807 2319.65,837.031C2322.13,834.693 2322.24,830.79 2319.9,828.315C2318.69,827.031 2317.06,826.383 2315.42,826.383ZM2383.59,656.548C2383.3,656.548 2383.02,656.567 2382.73,656.607C2379.35,657.083 2377,660.2 2377.48,663.572C2377.59,664.329 2387.42,739.87 2329.12,809.11C2326.92,811.716 2327.26,815.606 2329.86,817.8C2330.53,818.362 2331.28,818.757 2332.07,818.992C2332.64,819.165 2333.24,819.25 2333.83,819.25C2335.59,819.25 2337.33,818.503 2338.55,817.054C2400.36,743.646 2390.15,665.16 2389.69,661.856C2389.26,658.773 2386.62,656.548 2383.59,656.548ZM2185.79,709.388L2191.39,751.673L2191.4,751.705C2191.49,752.382 2191.84,753.053 2192.44,753.591C2193.15,754.226 2194.08,754.548 2194.97,754.548C2195.78,754.548 2196.56,754.289 2197.16,753.766L2221.05,732.671L2223.21,747.595L2223.23,747.728C2223.25,747.835 2223.27,747.943 2223.3,748.051C2223.69,749.486 2225.17,750.505 2226.76,750.505C2226.93,750.505 2227.11,750.492 2227.29,750.466L2252.13,746.791C2253.9,746.529 2254.98,745.021 2254.54,743.425C2254.15,741.989 2252.67,740.969 2251.09,740.969C2250.91,740.969 2250.73,740.982 2250.55,741.008L2229.63,744.104L2228.68,724.039C2228.62,722.991 2228.09,721.917 2227.11,721.125C2226.2,720.385 2225.06,720.015 2223.96,720.015C2222.83,720.015 2221.74,720.404 2220.95,721.18L2220.9,721.229L2197.58,744.254L2195.27,700.872L2195.27,700.8C2195.21,699.742 2194.74,698.665 2193.86,697.775C2192.74,696.642 2191.18,696.053 2189.67,696.053C2188.53,696.053 2187.41,696.386 2186.52,697.07L2156.73,719.829C2155.51,720.764 2155.33,722.448 2156.37,723.718C2157.08,724.581 2158.18,725.049 2159.26,725.049C2159.87,725.049 2160.48,724.895 2161.01,724.572L2185.79,709.388Z",
    style: {
      fill: "url(#_Linear21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.25,966.556L2249.28,761.912C2251.29,757.684 2254.36,755.359 2256.14,756.719C2257.92,758.08 2257.74,762.61 2255.73,766.838C2255.68,766.95 2255.61,767.089 2255.56,767.199L2154.54,968.48C2153.78,969.994 2152.66,970.761 2152.05,970.193C2151.46,969.643 2151.55,968.032 2152.25,966.556Z",
    style: {
      fill: "url(#_Linear22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2117.51,958.036L2148.58,733.696C2149.23,729.062 2147.93,725.434 2145.7,725.595C2143.46,725.755 2141.13,729.643 2140.49,734.277C2140.47,734.4 2140.45,734.554 2140.44,734.676L2114.54,958.393C2114.35,960.075 2114.86,961.327 2115.68,961.188C2116.48,961.054 2117.29,959.654 2117.51,958.036Z",
    style: {
      fill: "url(#_Linear23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194.97,754.548C2194.08,754.548 2193.15,754.226 2192.44,753.591C2191.84,753.053 2191.49,752.382 2191.4,751.705L2191.39,751.673L2185.79,709.388L2161.01,724.572C2160.48,724.895 2159.87,725.049 2159.26,725.049C2158.18,725.049 2157.08,724.581 2156.37,723.718C2155.33,722.448 2155.51,720.764 2156.73,719.829L2186.52,697.07C2187.41,696.386 2188.53,696.053 2189.67,696.053C2191.18,696.053 2192.74,696.642 2193.86,697.775C2194.74,698.665 2195.21,699.742 2195.27,700.8L2195.27,700.872L2197.58,744.254L2220.9,721.229L2220.95,721.18C2221.74,720.404 2222.83,720.015 2223.96,720.015C2225.06,720.015 2226.2,720.385 2227.11,721.125C2228.09,721.917 2228.62,722.991 2228.68,724.039L2229.63,744.104L2250.55,741.008C2250.73,740.982 2250.91,740.969 2251.09,740.969C2252.67,740.969 2254.15,741.989 2254.54,743.425C2254.98,745.021 2253.9,746.529 2252.13,746.791L2227.29,750.466C2227.11,750.492 2226.93,750.505 2226.76,750.505C2225.17,750.505 2223.69,749.486 2223.3,748.051C2223.27,747.943 2223.25,747.835 2223.23,747.728L2223.21,747.595L2221.05,732.671L2197.16,753.766C2196.56,754.289 2195.78,754.548 2194.97,754.548Z",
    style: {
      fill: "url(#_Linear24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2292.8,857.708C2292.2,857.708 2291.61,857.621 2291.03,857.449C2289.81,857.083 2288.68,856.335 2287.86,855.234C2285.82,852.508 2286.38,848.644 2289.11,846.603C2296.93,840.754 2304.36,834.518 2311.19,828.067C2312.38,826.942 2313.9,826.383 2315.42,826.383C2317.06,826.383 2318.69,827.031 2319.9,828.315C2322.24,830.79 2322.13,834.693 2319.65,837.031C2312.48,843.807 2304.69,850.349 2296.49,856.48C2295.38,857.308 2294.09,857.708 2292.8,857.708Z",
    style: {
      fill: "url(#_Linear25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2333.83,819.25C2333.24,819.25 2332.64,819.165 2332.07,818.992C2331.28,818.757 2330.53,818.362 2329.86,817.8C2327.26,815.606 2326.92,811.716 2329.12,809.11C2387.42,739.87 2377.59,664.329 2377.48,663.572C2377,660.2 2379.35,657.083 2382.73,656.607C2383.02,656.567 2383.3,656.548 2383.59,656.548C2386.62,656.548 2389.26,658.773 2389.69,661.856C2390.15,665.16 2400.36,743.646 2338.55,817.054C2337.33,818.503 2335.59,819.25 2333.83,819.25Z",
    style: {
      fill: "url(#_Linear26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2655.34,621.379C2655.34,700.836 2590.93,765.249 2511.47,765.249C2432.02,765.249 2367.61,700.836 2367.61,621.379C2367.61,541.922 2432.02,477.509 2511.47,477.509C2590.93,477.509 2655.34,541.922 2655.34,621.379Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2511.47,546.275C2470.06,546.275 2436.37,579.967 2436.37,621.379C2436.37,662.791 2470.06,696.482 2511.47,696.482C2552.89,696.482 2586.58,662.791 2586.58,621.379C2586.58,579.967 2552.89,546.275 2511.47,546.275ZM2511.47,711.601C2461.73,711.601 2421.25,671.127 2421.25,621.379C2421.25,571.63 2461.73,531.156 2511.47,531.156C2561.22,531.156 2601.7,571.63 2601.7,621.379C2601.7,671.127 2561.22,711.601 2511.47,711.601Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2483.21,656.124L2483.21,591.261C2483.21,584.33 2490.76,580.034 2496.72,583.571L2551.37,616.003C2557.21,619.467 2557.21,627.918 2551.37,631.382L2496.72,663.814C2490.76,667.351 2483.21,663.055 2483.21,656.124Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.1,838.65C1295.1,922.146 1227.42,989.833 1143.92,989.833C1060.43,989.833 992.738,922.146 992.738,838.65C992.738,755.154 1060.43,687.467 1143.92,687.467C1227.42,687.467 1295.1,755.154 1295.1,838.65Z",
    style: {
      fill: "rgb(145,179,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.92,743.217C1105.9,743.217 1074.97,771.403 1074.97,806.049C1074.97,824.049 1095.35,868.035 1130.88,926.729C1133.66,931.334 1138.54,934.082 1143.92,934.082C1149.3,934.082 1154.18,931.334 1156.97,926.729C1192.49,868.035 1212.87,824.049 1212.87,806.049C1212.87,771.403 1181.94,743.217 1143.92,743.217ZM1143.92,944.271C1134.94,944.271 1126.81,939.687 1122.16,932.005C1095.99,888.763 1064.79,831.808 1064.79,806.049C1064.79,765.785 1100.29,733.028 1143.92,733.028C1187.56,733.028 1223.06,765.785 1223.06,806.049C1223.06,831.808 1191.86,888.763 1165.68,932.005C1161.03,939.687 1152.9,944.271 1143.92,944.271Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.79,857.044C1110.73,857.044 1088.72,835.028 1088.72,807.967C1088.72,805.153 1091,802.872 1093.81,802.872C1096.62,802.872 1098.9,805.153 1098.9,807.967C1098.9,829.41 1116.35,846.855 1137.79,846.855C1159.23,846.855 1176.68,829.41 1176.68,807.967C1176.68,786.524 1159.23,769.078 1137.79,769.078C1125.39,769.078 1114.02,774.787 1106.6,784.74C1104.92,786.996 1101.72,787.461 1099.47,785.777C1097.21,784.095 1096.75,780.903 1098.43,778.648C1107.66,766.275 1122.37,758.889 1137.79,758.889C1164.85,758.889 1186.87,780.905 1186.87,807.967C1186.87,835.028 1164.85,857.044 1137.79,857.044Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706.18,1727.38C2289.85,1754.5 1865.14,1752.65 1432.93,1724.95C1383.1,1721.76 1340.68,1687.47 1326.96,1639.46L1172.18,1097.96C1169.68,1089.21 1176.77,1080.7 1185.84,1081.57C1774,1138.14 2373.9,1136.65 2984.85,1081.47C2993.97,1080.64 3001.07,1089.22 2998.53,1098.02L2850.05,1611.66C2831.26,1676.68 2773.73,1722.98 2706.18,1727.38Z",
    style: {
      fill: "url(#_Linear27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2509.19,2707.3C2419.73,2707.3 2343.33,2651.43 2312.96,2572.67C2306.49,2555.89 2302.11,2538.07 2300.14,2519.53C2299.35,2512.14 2298.95,2504.65 2298.95,2497.06C2298.95,2491.18 2299.19,2485.36 2299.67,2479.61C2308.53,2371.66 2398.96,2286.82 2509.19,2286.82C2560.55,2286.82 2607.61,2305.24 2644.13,2335.83C2690.16,2374.39 2719.43,2432.31 2719.43,2497.06C2719.43,2601.75 2642.91,2688.56 2542.75,2704.64C2531.82,2706.39 2520.62,2707.3 2509.19,2707.3ZM2509.19,2293.81C2396.94,2293.81 2305.94,2384.81 2305.94,2497.06C2305.94,2609.31 2396.94,2700.31 2509.19,2700.31C2621.44,2700.31 2712.44,2609.31 2712.44,2497.06C2712.44,2384.81 2621.44,2293.81 2509.19,2293.81Z",
    style: {
      fill: "url(#_Linear28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2509.19,2700.31C2396.94,2700.31 2305.94,2609.31 2305.94,2497.06C2305.94,2384.81 2396.94,2293.81 2509.19,2293.81C2621.44,2293.81 2712.44,2384.81 2712.44,2497.06C2712.44,2609.31 2621.44,2700.31 2509.19,2700.31ZM2513.62,2329.46C2418.61,2329.46 2341.6,2406.48 2341.6,2501.49C2341.6,2596.49 2418.61,2673.51 2513.62,2673.51C2608.63,2673.51 2685.65,2596.49 2685.65,2501.49C2685.65,2406.48 2608.63,2329.46 2513.62,2329.46ZM2509.19,2304.77C2436.17,2304.77 2370.36,2345.29 2337.43,2410.53C2336.27,2412.83 2337.2,2415.63 2339.49,2416.79C2340.17,2417.13 2340.89,2417.29 2341.59,2417.29C2343.3,2417.29 2344.94,2416.35 2345.76,2414.73C2377.09,2352.66 2439.71,2314.1 2509.19,2314.1C2520.28,2314.1 2531.39,2315.1 2542.2,2317.07C2542.48,2317.12 2542.76,2317.14 2543.03,2317.14C2545.24,2317.14 2547.22,2315.58 2547.63,2313.32C2548.09,2310.79 2546.41,2308.36 2543.88,2307.89C2532.51,2305.82 2520.84,2304.77 2509.19,2304.77Z",
    style: {
      fill: "url(#_Linear29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2341.59,2417.29C2340.89,2417.29 2340.17,2417.13 2339.49,2416.79C2337.2,2415.63 2336.27,2412.83 2337.43,2410.53C2370.36,2345.29 2436.17,2304.77 2509.19,2304.77C2520.84,2304.77 2532.51,2305.82 2543.88,2307.89C2546.41,2308.36 2548.09,2310.79 2547.63,2313.32C2547.22,2315.58 2545.24,2317.14 2543.03,2317.14C2542.76,2317.14 2542.48,2317.12 2542.2,2317.07C2531.39,2315.1 2520.28,2314.1 2509.19,2314.1C2439.71,2314.1 2377.09,2352.66 2345.76,2414.73C2344.94,2416.35 2343.3,2417.29 2341.59,2417.29Z",
    style: {
      fill: "url(#_Linear30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2513.62,2673.51C2418.61,2673.51 2341.6,2596.49 2341.6,2501.49C2341.6,2406.48 2418.61,2329.46 2513.62,2329.46C2608.63,2329.46 2685.65,2406.48 2685.65,2501.49C2685.65,2596.49 2608.63,2673.51 2513.62,2673.51Z",
    style: {
      fill: "url(#_Linear31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2711.54,2840.28L2306.85,2840.28C2304.84,2840.28 2303.22,2838.65 2303.22,2836.65L2303.22,2765.45C2303.22,2763.44 2304.84,2761.81 2306.85,2761.81L2711.54,2761.81C2713.54,2761.81 2715.17,2763.44 2715.17,2765.45L2715.17,2836.65C2715.17,2838.65 2713.54,2840.28 2711.54,2840.28Z",
    style: {
      fill: "url(#_Linear32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2711.86,2933.46L2307.17,2933.46C2305.17,2933.46 2303.54,2931.83 2303.54,2929.83L2303.54,2858.63C2303.54,2856.62 2305.17,2854.99 2307.17,2854.99L2711.86,2854.99C2713.87,2854.99 2715.49,2856.62 2715.49,2858.63L2715.49,2929.83C2715.49,2931.83 2713.87,2933.46 2711.86,2933.46Z",
    style: {
      fill: "url(#_Linear33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2712.18,3026.64L2307.5,3026.64C2305.49,3026.64 2303.86,3025.01 2303.86,3023.01L2303.86,2951.81C2303.86,2949.8 2305.49,2948.17 2307.5,2948.17L2712.18,2948.17C2714.19,2948.17 2715.82,2949.8 2715.82,2951.81L2715.82,3023.01C2715.82,3025.01 2714.19,3026.64 2712.18,3026.64Z",
    style: {
      fill: "url(#_Linear34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2712.51,3119.82L2307.82,3119.82C2305.81,3119.82 2304.19,3118.19 2304.19,3116.19L2304.19,3044.99C2304.19,3042.98 2305.81,3041.35 2307.82,3041.35L2712.51,3041.35C2714.51,3041.35 2716.14,3042.98 2716.14,3044.99L2716.14,3116.19C2716.14,3118.19 2714.51,3119.82 2712.51,3119.82Z",
    style: {
      fill: "url(#_Linear35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2712.83,3213L2308.14,3213C2306.14,3213 2304.51,3211.37 2304.51,3209.37L2304.51,3138.17C2304.51,3136.16 2306.14,3134.53 2308.14,3134.53L2712.83,3134.53C2714.84,3134.53 2716.46,3136.16 2716.46,3138.17L2716.46,3209.37C2716.46,3211.37 2714.84,3213 2712.83,3213Z",
    style: {
      fill: "url(#_Linear36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2969.47,2801.28C2902.26,2801.28 2842.42,2769.75 2803.94,2720.67C2775.93,2684.95 2759.23,2639.95 2759.23,2591.04C2759.23,2474.93 2853.36,2380.8 2969.47,2380.8C2997.87,2380.8 3024.95,2386.43 3049.66,2396.63C3125.99,2428.15 3179.71,2503.33 3179.71,2591.04C3179.71,2707.15 3085.58,2801.28 2969.47,2801.28ZM2969.47,2387.79C2857.22,2387.79 2766.22,2478.79 2766.22,2591.04C2766.22,2703.29 2857.22,2794.29 2969.47,2794.29C3081.72,2794.29 3172.72,2703.29 3172.72,2591.04C3172.72,2478.79 3081.72,2387.79 2969.47,2387.79Z",
    style: {
      fill: "url(#_Linear37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2969.47,2794.29C2857.22,2794.29 2766.22,2703.29 2766.22,2591.04C2766.22,2478.79 2857.22,2387.79 2969.47,2387.79C3081.72,2387.79 3172.72,2478.79 3172.72,2591.04C3172.72,2703.29 3081.72,2794.29 2969.47,2794.29ZM2973.9,2423.44C2878.89,2423.44 2801.87,2500.46 2801.87,2595.47C2801.87,2690.48 2878.89,2767.5 2973.9,2767.5C3068.91,2767.5 3145.92,2690.48 3145.92,2595.47C3145.92,2500.46 3068.91,2423.44 2973.9,2423.44ZM2969.47,2398.76C2896.45,2398.76 2830.64,2439.28 2797.71,2504.51C2796.55,2506.81 2797.47,2509.61 2799.77,2510.77C2800.45,2511.11 2801.16,2511.27 2801.87,2511.27C2803.57,2511.27 2805.22,2510.34 2806.03,2508.71C2837.37,2446.64 2899.99,2408.08 2969.47,2408.08C2980.57,2408.08 2991.68,2409.08 3002.48,2411.05C3002.77,2411.1 3003.05,2411.13 3003.32,2411.13C3005.53,2411.13 3007.49,2409.55 3007.91,2407.3C3008.37,2404.77 3006.69,2402.34 3004.15,2401.88C2992.8,2399.81 2981.13,2398.76 2969.47,2398.76Z",
    style: {
      fill: "url(#_Linear38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2801.87,2511.27C2801.16,2511.27 2800.45,2511.11 2799.77,2510.77C2797.47,2509.61 2796.55,2506.81 2797.71,2504.51C2830.64,2439.28 2896.45,2398.76 2969.47,2398.76C2981.13,2398.76 2992.8,2399.81 3004.15,2401.88C3006.69,2402.34 3008.37,2404.77 3007.91,2407.3C3007.49,2409.55 3005.53,2411.13 3003.32,2411.13C3003.05,2411.13 3002.77,2411.1 3002.48,2411.05C2991.68,2409.08 2980.57,2408.08 2969.47,2408.08C2899.99,2408.08 2837.37,2446.64 2806.03,2508.71C2805.22,2510.34 2803.57,2511.27 2801.87,2511.27Z",
    style: {
      fill: "url(#_Linear39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2973.9,2767.5C2878.89,2767.5 2801.87,2690.48 2801.87,2595.47C2801.87,2500.46 2878.89,2423.44 2973.9,2423.44C3068.91,2423.44 3145.92,2500.46 3145.92,2595.47C3145.92,2690.48 3068.91,2767.5 2973.9,2767.5Z",
    style: {
      fill: "url(#_Linear40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3171.81,2934.26L2767.13,2934.26C2765.12,2934.26 2763.49,2932.63 2763.49,2930.63L2763.49,2859.43C2763.49,2857.42 2765.12,2855.79 2767.13,2855.79L3171.81,2855.79C3173.82,2855.79 3175.45,2857.42 3175.45,2859.43L3175.45,2930.63C3175.45,2932.63 3173.82,2934.26 3171.81,2934.26Z",
    style: {
      fill: "url(#_Linear41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3172.14,3027.44L2767.45,3027.44C2765.44,3027.44 2763.82,3025.82 2763.82,3023.81L2763.82,2952.61C2763.82,2950.6 2765.44,2948.97 2767.45,2948.97L3172.14,2948.97C3174.14,2948.97 3175.77,2950.6 3175.77,2952.61L3175.77,3023.81C3175.77,3025.82 3174.14,3027.44 3172.14,3027.44Z",
    style: {
      fill: "url(#_Linear42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3172.46,3120.62L2767.77,3120.62C2765.77,3120.62 2764.14,3119 2764.14,3116.99L2764.14,3045.79C2764.14,3043.78 2765.77,3042.16 2767.77,3042.16L3172.46,3042.16C3174.47,3042.16 3176.09,3043.78 3176.09,3045.79L3176.09,3116.99C3176.09,3119 3174.47,3120.62 3172.46,3120.62Z",
    style: {
      fill: "url(#_Linear43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3172.78,3213.8L2768.1,3213.8C2766.09,3213.8 2764.46,3212.18 2764.46,3210.17L2764.46,3138.97C2764.46,3136.96 2766.09,3135.33 2768.1,3135.33L3172.78,3135.33C3174.79,3135.33 3176.42,3136.96 3176.42,3138.97L3176.42,3210.17C3176.42,3212.18 3174.79,3213.8 3172.78,3213.8Z",
    style: {
      fill: "url(#_Linear44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.67,2418.55C1080.49,2431.42 1083.58,2443.91 1091.58,2446.46C1099.58,2449.01 1109.46,2440.64 1113.64,2427.77C1117.83,2414.91 1114.73,2402.41 1106.73,2399.87C1098.74,2397.32 1088.86,2405.68 1084.67,2418.55Z",
    style: {
      fill: "rgb(125,151,244)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1992.54,-2150.68,2150.68,-1992.54,3376.98,3519.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(218,226,253)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(232,239,253)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1194.46,1806.61,-1806.61,-1194.46,2376.51,-490.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1194.46,1806.61,-1806.61,-1194.46,2376.51,-490.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1194.46,1806.61,-1806.61,-1194.46,2376.51,-490.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1194.46,1806.61,-1806.61,-1194.46,2376.51,-490.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(423.037,-970.496,970.496,423.037,1148.46,3838.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(79,82,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(63,66,226)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(423.037,-970.496,970.496,423.037,1148.46,3838.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(165,167,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(158,158,239)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(423.037,-970.496,970.496,423.037,1148.46,3838.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(165,167,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(158,158,239)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(423.037,-970.496,970.496,423.037,1148.46,3838.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(165,167,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(158,158,239)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(383.219,-960.537,960.537,383.219,1706.49,3497.83)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(79,82,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(63,66,226)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1045.14,1040.17,-1040.17,1045.14,1722.2,2399.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(79,82,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(63,66,226)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1468.18,2398.85,-2398.85,-1468.18,2918.46,-278.247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(225,70,61)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(232,96,89)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(99.7458,-992.67,992.67,99.7458,1460.35,1179.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(79,82,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(63,66,226)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(87.9293,209.04,-209.04,87.9293,2401.55,967.315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8,0,93)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(26,14,144)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(169.214,517.594,-517.594,169.214,2408.02,70.949)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(79,82,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(63,66,226)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-274.296,236.691,-236.691,-274.296,3288.02,529.53)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(79,82,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(63,66,226)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear19",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-132.724,152.632,-152.632,-132.724,2940.01,806.003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8,0,93)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(26,14,144)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear20",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(106.179,187.472,-187.472,106.179,2334.77,788.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8,0,93)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(26,14,144)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear21",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(358.353,-499.924,499.924,358.353,1981.53,1015.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear22",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(365.651,-366.393,366.393,365.651,451.294,2618.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(225,70,61)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(232,96,89)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear23",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(365.657,-366.4,366.4,365.657,404.737,2572.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(225,70,61)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(232,96,89)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear24",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(358.353,-499.924,499.924,358.353,1981.53,1015.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear25",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(358.353,-499.924,499.924,358.353,1981.53,1015.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear26",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(358.353,-499.924,499.924,358.353,1981.53,1015.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear27",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(278.747,955.705,-955.705,278.747,2075.13,1064.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear28",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(281.999,-327.32,327.32,281.999,2221.5,2830.99)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(225,70,61)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(232,96,89)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear29",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-833.879,1259.75,-1259.75,-833.879,2662.84,2264.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear30",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-833.879,1259.75,-1259.75,-833.879,2662.84,2264.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear31",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-833.879,1259.75,-1259.75,-833.879,2662.84,2264.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,230,230)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255,223,221)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear32",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(539.492,-753.251,753.251,539.492,2085.93,3392.01)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear33",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(539.491,-753.25,753.25,539.491,2131.25,3422.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear34",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(539.491,-753.25,753.25,539.491,2176.57,3452.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear35",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(539.492,-753.251,753.251,539.492,2221.89,3483.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear36",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(539.491,-753.25,753.25,539.491,2267.21,3513.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear37",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(281.999,-327.32,327.32,281.999,2681.78,2924.97)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(225,70,61)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(232,96,89)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear38",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-833.878,1259.75,-1259.75,-833.878,3123.12,2358.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear39",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-833.878,1259.75,-1259.75,-833.878,3123.12,2358.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,198,196)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,181,174)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear40",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-833.878,1259.75,-1259.75,-833.878,3123.12,2358.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,230,230)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255,223,221)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear41",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-457.897,590.179,-590.179,-457.897,3132.44,2684.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear42",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-457.897,590.179,-590.179,-457.897,3178.77,2718.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear43",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-457.897,590.179,-590.179,-457.897,3225.1,2752.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear44",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-457.897,590.179,-590.179,-457.897,3271.44,2786.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255,145,142)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(253,112,98)",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderArchive);
export default __webpack_public_path__ + "static/media/header-archive.ef35e98a3275c78d262dfc4b262bbd21.svg";
export { ForwardRef as ReactComponent };